import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const THRESHOLD_PX = 300;

export default function ScrollToTopButton({ scrollContainer }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!scrollContainer) return;

    const onScroll = () => {
      setVisible(scrollContainer.scrollTop > THRESHOLD_PX);
    };

    scrollContainer.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      scrollContainer.removeEventListener("scroll", onScroll);
    };
  }, [scrollContainer]);

  if (!scrollContainer) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="secondary"
      size="icon"
      aria-label="Voltar ao topo"
      className={cn(
        "fixed bottom-4 right-4 z-20 rounded-full shadow-md transition-all duration-200",
        visible
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-2 opacity-0"
      )}
      onClick={() => {
        scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      <ChevronUp className="h-5 w-5" />
    </Button>
  );
}
